// src/enums/ChainId.ts
var ChainId = /* @__PURE__ */ ((ChainId2) => {
  ChainId2[ChainId2["SMARTBCH"] = 1e4] = "SMARTBCH";
  ChainId2[ChainId2["SMARTBCH_TESTNET"] = 10001] = "SMARTBCH_TESTNET";
  ChainId2[ChainId2["BSC"] = 56] = "BSC";
  ChainId2[ChainId2["BSC_TESTNET"] = 97] = "BSC_TESTNET";
  return ChainId2;
})(ChainId || {});
var ChainId_default = ChainId;

// src/enums/Rounding.ts
var Rounding = /* @__PURE__ */ ((Rounding2) => {
  Rounding2[Rounding2["ROUND_DOWN"] = 0] = "ROUND_DOWN";
  Rounding2[Rounding2["ROUND_HALF_UP"] = 1] = "ROUND_HALF_UP";
  Rounding2[Rounding2["ROUND_UP"] = 3] = "ROUND_UP";
  return Rounding2;
})(Rounding || {});
var Rounding_default = Rounding;

// src/enums/VersionUpgrade.ts
var VersionUpgrade = /* @__PURE__ */ ((VersionUpgrade2) => {
  VersionUpgrade2[VersionUpgrade2["NONE"] = 0] = "NONE";
  VersionUpgrade2[VersionUpgrade2["PATCH"] = 1] = "PATCH";
  VersionUpgrade2[VersionUpgrade2["MINOR"] = 2] = "MINOR";
  VersionUpgrade2[VersionUpgrade2["MAJOR"] = 3] = "MAJOR";
  return VersionUpgrade2;
})(VersionUpgrade || {});
var VersionUpgrade_default = VersionUpgrade;

// src/enums/Fee.ts
var Fee = /* @__PURE__ */ ((Fee2) => {
  Fee2[Fee2["LOW"] = 1] = "LOW";
  Fee2[Fee2["MEDIUM"] = 5] = "MEDIUM";
  Fee2[Fee2["AVERAGE"] = 10] = "AVERAGE";
  Fee2[Fee2["DEFAULT"] = 30] = "DEFAULT";
  Fee2[Fee2["HIGH"] = 100] = "HIGH";
  return Fee2;
})(Fee || {});

// src/enums/TradeType.ts
var TradeType = /* @__PURE__ */ ((TradeType2) => {
  TradeType2[TradeType2["EXACT_INPUT"] = 0] = "EXACT_INPUT";
  TradeType2[TradeType2["EXACT_OUTPUT"] = 1] = "EXACT_OUTPUT";
  return TradeType2;
})(TradeType || {});

// src/enums/Version.ts
var Version = /* @__PURE__ */ ((Version2) => {
  Version2[Version2["V1"] = 0] = "V1";
  Version2[Version2["V2"] = 1] = "V2";
  return Version2;
})(Version || {});
export {
  ChainId_default as ChainId,
  Fee,
  Rounding_default as Rounding,
  TradeType,
  Version,
  VersionUpgrade_default as VersionUpgrade
};
//# sourceMappingURL=index.mjs.map